import "./SectionHeading.css";

export default function SectionHeading({ text }) {
  return <h3 className="pb-3">{text}</h3>;
}
